<template>
  <div>
    <v-autocomplete
      :value="city"
      :items="filterCityGroups"
      :label="label == null ? label : $i18n.t('City Group(s)')"
      @change="changedTo"
      :multiple="multiple"
      :loading="loading"
      ref="select"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      autocomplete="nope1"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="multiple === '' || multiple">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
            <v-icon small @click="remove(data.item)" style="float:right;margin-left:5px;">mdi-close</v-icon>
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CityGroupSelect",
  props: {
    value: {
      default: false
    },
    country: {
      default: false
    },
    label: {
      default: null
    },
    multiple: {
      default: false
    },
    object: {
      default: false
    },
    clearable: {
      default: false
    },
    rules: {
      default: () => []
    }
  }
})
export default class CityGroupSelect extends (Vue, Themeable) {
  city = null;
  cityGroups = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.city = null;
    this.$emit("input", null);
  }

  get filterCityGroups() {
    if (this.cityGroups == null || this.cityGroups.length == 0) {
      return [];
    }
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby === "") return this.cityGroups;
    if (filterby == "") {
      return this.cityGroups;
    } else {
      const fc = this.cityGroups.filter(function(c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (this.multiple === false || this.multiple != "") {
      if (newVal) this.city = newVal;
      if (newVal && newVal._id) {
        if (this.object === false) this.$emit("input", newVal._id);
        else this.$emit("input", { _id: newVal._id, name: newVal.name });
      }
      if (!newVal) this.$emit("input", null);
    } else {
      const response = [];
      this.city = newVal;

      for (let i = 0; i < newVal.length; i++) {
        if (this.object === false) response.push(newVal[i]._id);
        else response.push({ _id: newVal[i]._id, name: newVal[i].name });
      }
      this.$emit("input", response);
    }
  }

  setValue() {
    if (
      (this.value &&
        this.cityGroups != null &&
        this.cityGroups.length > 0 &&
        this.multiple === false) ||
      this.multiple === false
    ) {
      if (this.cityGroups) {
        for (let i = 0; i < this.cityGroups.length; i++) {
          if (this.cityGroups[i]._id === this.value) {
            this.city = this.cityGroups[i];
            break;
          }
        }
      }
    } else if (this.cityGroups.length > 0) {
      this.city = [];
      if (
        this.value != null &&
        this.value != "" &&
        this.cityGroups.length > 0
      ) {
        for (let i = 0; i < this.cityGroups.length; i++) {
          if (
            this.value.filter(e => e === this.cityGroups[i]._id).length > 0 ||
            this.value.filter(e => e._id === this.cityGroups[i]._id).length > 0
          ) {
            this.city.push(this.cityGroups[i]);
          }
        }
      }
    }
    this.loading = false;
  }

  async mounted() {
    await common.populateCityGroups(this.country);
    if (common.cityGroups[this.country] != undefined)
      this.cityGroups = common.cityGroups[this.country];
    this.setValue();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val._id != null && this.city != null) {
      if (Array.isArray(this.city)) {
        for (let i = 0; i < this.city.length; i++) {
          if (val._id === this.city[i]._id) {
            return true;
          }
        }
      } else if (this.city != null && this.city._id != undefined) {
        if (val._id === this.city._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("country")
  async onCountryChange(val) {
    this.filter = "";
    this.loading = true;
    this.cityGroups = [];
    if (common.cityGroups[val] == undefined)
      await common.populateCityGroups(val);
    const cityGroups = common.cityGroups[this.country];
    if (cityGroups != null && cityGroups.length > 0)
      this.cityGroups = cityGroups;
    this.setValue();
  }

  remove(val) {
    if (val != null && val._id != null && this.city != null) {
      if (Array.isArray(this.city)) {
        for (let i = 0; i < this.city.length; i++) {
          if (val._id === this.city[i]._id) {
            this.city.splice(i, 1);
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
